module.exports = __webpack_public_path__ + "media/images/user-bf16808152c30e5f08e45edc0162fd9d.png";